export default __webpack_public_path__ + "static/media/RightArrow_3.a0870244.svg";